import React from "react";
import {
  handleChange,
  handleChangeNameValue,
} from "../../../helpers/handleFormChanges";
import CommonModal from "../../../components/Common/CommonModal";
import CommonButton from "../../../components/buttons/CommonButton";
import CommonInput from "../../../components/forms/CommonInput";
import { formataDataMes } from "../../../helpers/mesesHelper";
import CommonDataTable from "../../../components/Datatable/CommonDataTable";
import { AppContext } from "../../../contexts/AppContext";
import Format from "../../../helpers/Format";
import Badge from "../../../components/Common/Badge/Badge";
import CommonInputValor from "../../../components/forms/CommonInputValor";
import PropTypes from "prop-types";

function ReajustarSalarioModal({
  isOpen,
  setIsOpen,
  valuesHook,
  historicoSalario,
  solicitarReajuste,
  togEditarReajusteModal,
  apagarReajuste,
  aprovarReajuste,
}) {
  const { values, setValues } = valuesHook;
  const { session } = React.useContext(AppContext);

  const tipos_status = React.useMemo(
    () => [
      { cor: "primary", texto: "Salário inicial" },
      { cor: "success", texto: "Aprovado" },
      { cor: "warning", texto: "Pendente" },
    ],
    []
  );

  const colunas = React.useMemo(
    () => [
      {
        Header: "Mês inicial",
        accessor: (row) => {
          return formataDataMes(row.mes_inicial);
        },
        disableSortBy: true,
      },
      {
        Header: "Mês final",
        accessor: (row) => {
          return formataDataMes(row.mes_final);
        },
        disableSortBy: true,
      },
      {
        Header: "Salário",
        accessor: (row) => {
          return Format.formataValor(row.valor);
        },
        disableSortBy: true,
      },
      {
        Header: "Aumento",
        accessor: (row) => {
          return row.aumento ? `${row.aumento}%` : "";
        },
        disableSortBy: true,
      },
      {
        Header: "Status",
        disableSortBy: true,
        Cell: ({ row }) => {
          let status = "";

          switch (parseInt(row.original.status)) {
            case 0:
              status = (
                <Badge color={tipos_status[0].cor}>
                  {tipos_status[0].texto}
                </Badge>
              );
              break;

            case 1:
              status = (
                <Badge color={tipos_status[1].cor}>
                  {tipos_status[1].texto}
                </Badge>
              );
              break;

            case 2:
              status = (
                <Badge color={tipos_status[2].cor}>
                  {tipos_status[2].texto}
                </Badge>
              );
              break;

            default:
              break;
          }
          return status;
        },
      },
      {
        Header: "Ações",
        disableSortBy: true,
        Cell: ({ row }) => {
          var status = [];

          if (parseInt(row.original.status) === 2) {
            status.push(
              <button
                onClick={() => {
                  togEditarReajusteModal(row.original.solicitacao_uid);
                }}
                title="Editar"
                style={{
                  background: "none",
                  border: "none",
                  width: "fit-content",
                }}
              >
                <i className="mdi mdi-file-document-edit font-size-16 text-primary font-size-18 me-1"></i>
              </button>
            );
            if (parseInt(session.codigo) === 99)
              status.push(
                <>
                  <button
                    onClick={() => {
                      aprovarReajuste(
                        row.original.solicitacao_uid,
                        row.original.valor
                      );
                    }}
                    title="Aprovar reajuste"
                    style={{
                      background: "none",
                      border: "none",
                      width: "fit-content",
                    }}
                  >
                    <i className="mdi mdi-checkbox-marked-circle-outline font-size-16 text-success font-size-18 me-1"></i>
                  </button>
                  <button
                    onClick={() => {
                      apagarReajuste(row.original.solicitacao_uid);
                    }}
                    title="Apagar reajuste"
                    style={{
                      background: "none",
                      border: "none",
                      width: "fit-content",
                    }}
                  >
                    <i className="mdi mdi-delete font-size-16 text-danger font-size-18 me-1"></i>
                  </button>
                </>
              );
          }

          return status.length > 0 && <div className="row">{status}</div>;
        },
      },
    ],
    [
      tipos_status,
      session.codigo,
      togEditarReajusteModal,
      aprovarReajuste,
      apagarReajuste,
    ]
  );

  return (
    <CommonModal
      title={"Reajustar salário"}
      is_open_modal={isOpen}
      set_is_open_modal={setIsOpen}
      size="xl"
      buttons={
        <CommonButton
          key={`reajustar-salario`}
          onClick={solicitarReajuste}
          color="success"
        >
          Confirmar solicitação
        </CommonButton>
      }
    >
      <div className="row">
        <div className="col-md-4 mb-3">
          <CommonInputValor
            label="Salário atual"
            id="salario_atual"
            value={values.salario_atual}
            onChange={(e) => {
              handleChangeNameValue(
                "salario_atual",
                e.target.value,
                values,
                setValues
              );
            }}
            required
            disabled
          />
        </div>
        <div className="col-md-4 mb-3">
          <CommonInputValor
            label="Novo salário"
            id="novo_salario"
            value={values.novo_salario}
            onChange={(e) => {
              handleChangeNameValue(
                "novo_salario",
                e.target.value,
                values,
                setValues
              );
            }}
            required
          />
        </div>
        <div className="col-md-4 mb-3">
          <CommonInput
            label="Mês do reajuste"
            id="mes_reajuste"
            value={values.mes_reajuste}
            onChange={(e) => {
              handleChange(e, values, setValues);
            }}
            type="month"
            hint="O mês de referência é o período em que o trabalho foi realizado e serve como base para calcular o pagamento dos colaboradores. Normalmente, o pagamento é feito até o quinto dia útil do mês seguinte."
            required
          />
        </div>
      </div>
      <div className="row mb-3">
        <h5 className="modal-title">Histórico</h5>
      </div>
      <CommonDataTable colunas={colunas} linhas={historicoSalario} />
    </CommonModal>
  );
}

ReajustarSalarioModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  setIsOpen: PropTypes.func.isRequired,
  valuesHook: PropTypes.shape({
    values: PropTypes.object.isRequired,
    setValues: PropTypes.func.isRequired,
  }).isRequired,
  historicoSalario: PropTypes.arrayOf(PropTypes.object).isRequired,
  solicitarReajuste: PropTypes.func.isRequired,
  togEditarReajusteModal: PropTypes.func.isRequired,
  apagarReajuste: PropTypes.func.isRequired,
  aprovarReajuste: PropTypes.func.isRequired,
  row: PropTypes.object,
};

export default ReajustarSalarioModal;
